import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useGetCompaniesBySearchParamQuery } from '@massilia/queries';
import { AutoComplete, useDebounce } from '@massilia/ui';
import { useStore } from '@tanstack/react-form';
import { Building } from 'lucide-react';
import { useMemo, useState } from 'react';
import { useFieldContext } from '../hooks/use-app-form.js';
import { DEFAULT_OPTION } from '../schemas/estimate/base-schemas.js';
import { FieldError } from './field-error.js';
export function CompanyAutocompleteField({ label, placeholder = 'Compagnie aérienne', valueField = 'id', }) {
    const [searchText, setSearchText] = useState('');
    const debouncedSearchText = useDebounce(searchText, 200);
    const { data: searchedOptions } = useGetCompaniesBySearchParamQuery({
        searchParam: debouncedSearchText || '',
    });
    const options = useMemo(() => {
        if (!searchedOptions)
            return [];
        return searchedOptions.companies.map((company) => ({
            icon: _jsx(Building, { className: "size-4 text-gray-500" }),
            key: `${company.iataCode}-${company.name}`,
            label: `${company.iataCode} - ${company.name}`,
            value: company[valueField],
        }));
    }, [searchedOptions, valueField]);
    const field = useFieldContext();
    const errors = useStore(field.store, (state) => state.meta.errors);
    const selectedOption = useMemo(() => {
        const currentValue = field.state.value?.value;
        if (!currentValue)
            return;
        const foundOption = options.find((opt) => opt.value === currentValue);
        if (foundOption)
            return foundOption;
        if (field.state.value?.label) {
            return field.state.value;
        }
        return;
    }, [options, field.state.value]);
    return (_jsxs("div", { className: "relative flex flex-col gap-2", children: [label && _jsx("label", { className: "text-sm font-medium", children: label }), _jsx(AutoComplete, { emptyMessage: "Aucune compagnie trouv\u00E9e", icon: _jsx(Building, { className: "h-4 w-4 text-gray-light-700" }), onBlurCallBack: () => {
                    field.handleBlur();
                }, onInputChange: (text) => {
                    setSearchText(text);
                }, onValueChange: (opt) => {
                    if (opt) {
                        field.handleChange({ label: opt.label, value: opt.value });
                    }
                    else {
                        field.handleChange(DEFAULT_OPTION);
                    }
                }, options: options, placeholder: placeholder, shouldFilter: false, value: selectedOption }), _jsx(FieldError, { errors: errors })] }));
}
